import ImplicitAuthProvider from '../ImplicitAuthProvider'

import { Auth0ClientOptions, Auth0Client } from '@auth0/auth0-spa-js'

export default class SpaAuth0ImplicitAuthProvider implements ImplicitAuthProvider {
  client: Auth0Client

  constructor (options: Auth0ClientOptions) {
    this.client = new Auth0Client(options)
  }

  redirect (): void {
    this.client.loginWithRedirect()
  }

  async asyncHandle (): Promise<void> {
    await this.client.handleRedirectCallback()
  }

  asyncRefresh (): Promise<void> {
    throw new Error('Method not implemented.')
  }

  asyncIsAuthenticated (): Promise<boolean> {
    return this.client.isAuthenticated()
  }

  asyncLogout (): Promise<void> {
    this.client.logout()
    return Promise.resolve()
  }

  async asyncGetToken (): Promise<string> {
    try {
      return this.client.getTokenSilently()
    } catch (error) {
      return ''
    }
  }

  asyncGetTokenExpiration (): Promise<Date> {
    throw new Error('Method not implemented.')
  }
}
